<template>
  <div id="SpaPage" :class="`Page ${$screen.device}`" >
    <page-header iconsize="40" icon="martini">
      <template v-slot:title>ПИТАНИЕ И ДОСУГ</template>
      <template v-slot:text>
        <p style="text-transform: uppercase">

        </p>
      </template>
    </page-header>

    <div class="section food" :style="{maxWidth:$ui.size.contentMaxWidth+'px'}">
      <div class="content ltr">
        <div class="imageContainer"><div class="image" :style="{backgroundImage: `url(${require('@/assets/photo/base/food.jpg')})`}"></div></div>
        <div class="description">
          <div class="title">ПИТАНИЕ</div>
          <div class="text" style="font-size: 14px">
            Питание в санатории осуществляется по системе «Шведский стол» и предполагает наличие большого выбора различных блюд, от основных до разнообразных закусок, горячих и прохладительных напитков в свободном доступе. Такая система питания очень комфортна для отдыхающих: отдыхающие могут выбрать блюда по своему вкусу на завтрак, обед и ужин. Меню «шведского стола» утверждается на неделю, в нем учитываются все особенности питания людей, находящихся на лечени.
          </div>
        </div>
      </div>

    </div>

    <div class="section club" :style="{maxWidth:$ui.size.contentMaxWidth+'px'}">
      <div class="content rtl">
        <div class="description" style="align-content: center !important; display: grid">
        <div class="title">НОЧНОЙ КЛУБ</div>
          <div class="text" style="font-size: 14px">
            В свободное от лечебных и спа процедур гости санатория имеют возможность провести свой досуг в спокойной обстановке за чашечкой чая или посетить ночной клуб "Белый Парус".
            В санатории ЭЛИТА часто проходят культурно-массовые мероприятия – от выступлений профессиональных артистов и танцоров до презентаций различных услуг и товаров. Созданы все условия для размещения больших групп и проведения банкетов, корпоративных мероприятий и семинаров. Мы сделаем ваш отдых ярким и запоминающимся.
          </div>
        </div>
        <div class="imageContainer" >
          <div class="image">
            <div class="blockGallery">
              <div class="blockImage" style="min-height: 100px" v-for="(dosugImage, dosugImageIndex) in images.club" :key="dosugImageIndex"
                   :style="{backgroundImage: 'url('+dosugImage.src+')'}"
                   @click="$dispatch('showLightBox', {images:images.club, imageIndex:dosugImageIndex})"
              ></div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="double"  :style="{maxWidth:$ui.size.contentMaxWidth+'px'}">
      <div class="block">
        <div class="image" :style="{backgroundImage: `url(${require('@/assets/photo/base/cinema.jpg')})`}"></div>
        <div class="title">КИНОЗАЛ</div>
        <div class="text">
          <p>
            К выбору отдыхающих новинки и классика зарубежного и отечественного кино. </p>
        </div>


      </div>

      <div class="block">
        <div class="image" :style="{backgroundImage: `url(${require('@/assets/photo/base/biliard.jpg')})`}"></div>
        <div class="title">БИЛЬЯРДНЫЙ ЗАЛ</div>
        <div class="text">
          <p>
            Партия в бильярд придется по вкусу мужской половине отдыхающих.
          </p>

        </div>
      </div>

      <div class="block">
        <div class="image" :style="{backgroundImage: `url(${require('@/assets/photo/base/library.jpg')})`}"></div>
        <div class="title">БИБЛИОТЕКА</div>
        <div class="text">
          <p>
            Незанятое лечебными процедурами время можно провести за чтением интересной книги.
          </p>
        </div>
      </div>

      <div class="block">
        <div class="image" :style="{backgroundImage: `url(${require('@/assets/photo/base/dvorik.jpg')})`}"></div>
        <div class="title">ВНУТРЕННИЙ ДВОРИК</div>
        <div class="text">Провердите вечер во внутреннем дворике у камина или принимая спа-процедуры</div>
      </div>
    </div>

  </div>
</template>

<script>

  import PageHeader from "@/components/PageHeader";
  export default {
    name: 'SpaPage',
    components: {PageHeader},
    data: () => ({
      images: {
        club: [
          {src: require('@/assets/photo/club/club1.jpg'), width: 940, height: 627},
          {src: require('@/assets/photo/club/club2.jpg'), width: 627, height: 940},
          {src: require('@/assets/photo/club/club3.jpg'), width: 627, height: 940},
          {src: require('@/assets/photo/club/club4.jpg'), width: 940, height: 627},
        ]
      }
    }),
  }
</script>


<style>

  .blockGallery{display: grid; grid-template-columns: 1fr 1fr; width: 100%; height: 100%}
  .blockGallery>.blockImage{display: grid;cursor: zoom-in; height: 100%; width: 100%; background-position: center; background-size: cover; min-height: 100px; }



  .Page{display: grid;justify-items: center;}
  .Page>.section{display: grid; grid-auto-flow: column;padding-top: 20px; padding-bottom: 20px; align-items: center}
  .Page>.section>.content{display: grid; background-color: #f6efec; grid-template-columns: 1fr 1fr;}
  .Page>.section>.content>.imageContainer{height:100%;  width: 100%; display: grid; align-items: center}
  .Page>.section>.content>.imageContainer>.image{ height:100%; background-color: #aaaaaa; background-position: center; background-size: cover; align-self: center;}
  .Page>.section>.content>.description{z-index:1;padding: 30px}
  .Page>.section>.content>.description>.title{font-size: 28px; font-weight: lighter}
  .Page>.section>.content>.description>.text{font-size: 13px}
  .Page>.section>.content.ltr>.imageContainer{padding-left: 20px}
  .Page>.section>.content.rtl>.imageContainer{padding-right: 20px}
  .Page>.section>.content>.imageContainer>.image{height: 105%}

  .Page.mobile>.section{padding: 0px; margin-bottom: 8px;}
  .Page.tablet>.section>.content.ltr{grid-template-columns: 1fr 2fr;}
  .Page.tablet>.section>.content.rtl{grid-template-columns: 2fr 1fr;}
  .Page.mobile>.section>.content{grid-template-columns: 1fr;}
  .Page.mobile>.section>.content>.imageContainer{position: unset; padding: 0; min-height: 240px}
  .Page.mobile>.section>.content>.imageContainer>.image{position: unset; padding: 0; margin: 0; width: 100%; height: 100%}
  .Page.mobile>.section>.content>.description>.title{font-size: 28px; font-weight: lighter; text-align: center; }
  .Page.mobile>.section>.content.rtl>.imageContainer{order:-1;}

  .Page>.section.pool>.content>.imageContainer{display: grid;}

  .Page>.double{;display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; column-gap: 4px;margin-bottom: 8px}
  .Page.tablet>.double{;display: grid; grid-template-columns: 1fr 1fr; column-gap: 4px}
  .Page.mobile>.double{;display: grid; grid-template-columns: 1fr}
  .Page>.double>.block{display: grid; background-color: #f6efec; align-content: flex-start; }
  .Page>.double>.block>.title{font-size: 18px; padding-top: 10px; font-weight: lighter; text-align: center; }
  .Page>.double>.block>.text{font-size: 12px;  padding: 10px 20px; padding-top: 0px }

  .Page>.double>.block>.image{display: grid; background-position: center; background-size: cover; height: 200px; width: 100%}


</style>